export default "__VITE_ASSET__CzuRQNUa__"